type Listener<T> = (detail: T) => void;

class PacketEventBus {
  private readonly target = new EventTarget();

  emit<T>(name: string, detail: T): void {
    this.target.dispatchEvent(new CustomEvent(name, { detail }));
  }

  on<T>(name: string, listener: Listener<T>): () => void {
    const handler = (event: Event) => listener((event as CustomEvent<T>).detail);
    this.target.addEventListener(name, handler);
    return () => this.target.removeEventListener(name, handler);
  }
}

export const eventBus = new PacketEventBus();

export const EVENTS = {
  screen: 'screen',
  hud: 'hud',
  announce: 'announce',
  lesson: 'lesson',
  effect: 'effect',
  error: 'error',
  pause: 'pause',
  resume: 'resume',
  objective: 'objective',
  settings: 'settings',
  update: 'update',
} as const;
